import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useShiftPayment = fundraisingId => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      loanService.shiftPayment(fundraisingId, payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.loan.payment_schedule, fundraisingId],
          });
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.loan.list] });
          return { success: true, data };
        }
        throw new Error('Error');
      }),
  });
};
